import { useSelector } from 'react-redux'
import Modal from '../Modal/Modal'
import props from '../../../redux/props'
import { useState } from 'react'
import Input from '../Input/Input'
import Button from '../Button/Button'
import { getUUID } from '../../../utility'
import { PencilIcon } from '@heroicons/react/24/solid'
import { Floor as FloorType } from '../../../types/Survey/Survey'
import Number from '../Input/Number'

type Props = {
  initData?: FloorType
  callback: (data: FloorType) => void
  invert?: boolean
}

const Upsert: React.FC<Props> = ({ initData, callback, invert = false }) => {
  const [open, setOpen] = useState<boolean>(false)
  const t = useSelector((s) => s[props.TRANSLATION])
  const [data, setData] = useState<FloorType>(initData || { uuid: getUUID(), name: '', squareMeter: 0 })

  const save = () => {
    callback(data)
    setOpen(false)
    if (!initData) {
      setData({ uuid: getUUID(), name: '', squareMeter: 0 })
    }
  }

  const toggle = () => setOpen(!open)

  const set = (key: keyof FloorType) => (value: string) => setData({ ...data, [key]: value })

  return (
    <div className="mt-1">
      {!initData && <Button invert={invert} small className="ml-auto" text={t.UI.floorManager.add} onClick={toggle} />}
      {initData && <PencilIcon className="fill-white w-5 cursor-pointer" onClick={toggle} />}
      <Modal
        invert={invert}
        noForm
        onConfirm={save}
        show={open}
        onClose={toggle}
        title={!!initData ? t.UI.floorManager.updateTitle : t.UI.floorManager.addTitle}
      >
        <div className="flex flex-col gap-3 mt-3">
          <Input invert={invert} label={t.generic.name} value={data.name} onChange={set('name')} />
          <Number
            invert={invert}
            suffix={t.generic.squareMeterSuffix}
            label={t.generic.squareMeter}
            value={data.squareMeter}
            onChange={set('squareMeter')}
          />
        </div>
      </Modal>
    </div>
  )
}

export default Upsert
